import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'
import { Cdn } from 'utils/assets'

export const RunningRecordsBookShelfWrapper = styled.div`
  margin-top: 10px;
  position: relative;
  background: ${tokens.colors.tertiaryLight};

  padding-top: ${tokens.spacing.insetLarge};
  padding-bottom: ${tokens.spacing.insetXxsmall};

  margin-bottom: 68px;

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    padding: 1px 0;
  }

  &:before {
    content: '';
    background-color: ${tokens.colors.tertiaryLight};
    width: 100vw;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    transform: translateX(-100%);

    background-image: url(${Cdn.getImageUrl('running-records/stars-left.svg')});
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: contain;
  }

  &:after {
    content: '';
    background-color: ${tokens.colors.tertiaryLight};
    width: 100vw;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(100%);

    background-image: url(${Cdn.getImageUrl(
      'running-records/stars-right.svg'
    )});
    background-repeat: no-repeat;
    background-position-x: left;
    background-size: contain;
  }
`
